var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,_vm._g({tag:"component",staticClass:"search-result",attrs:{"item":_vm.item,"send-event":_vm.sendEvent}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }